import React, { Component } from 'react'
import { Redirect, Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { Body, Drawer } from '../Shell/Shell'
import Table from 'components/Table/Table'
import TableControls from 'components/Table/TableControls'
import { ConfirmDialog } from '../Modal/Modal'
import { PageError } from '../PageError/PageError'
import {
  fetchAndSetWorkQueueItems,
  selectWorkQueueItem,
  setActiveCategory,
  setFilters,
} from './MyWorkQueueActions'
import { setCartQuantity, setErrorToast } from '../../actions'
import { Spinner } from '../Loaders/Loaders'
// import orderBy from 'lodash/orderBy'
import './MyWorkQueue.scss'
import {
  BASE_URL,
  DELETE_DRAFT_BY_ID,
  DELETE_RECORD_BY_ID,
  GET_RECEIPT_ITEMS_BY_ADMENDMENT_NUM,
  GET_WEB_USER_ACTIVE_CART,
} from '../../requests'
import ReportsList from './ReportsList'
import EmptyBox from '../MyRecords/EmptyBox'
import {
  getOrderedResultsByCategory,
  calculateReceiptItemsTotal,
  calculateReceiptItemContainersTotal,
  noop
} from 'utilities'
import CartIcon from '@tecuity/sos-icons/react/cart'
import TrashIcon from '@tecuity/sos-icons/react/trash'
import DocumentIcon from '@tecuity/sos-icons/react/document'
import PencilIcon from '@tecuity/sos-icons/react/pencil'
import DownloadIcon from '@tecuity/sos-icons/react/download-box'
import SignatureIcon from '@tecuity/sos-icons/react/signature'
// import { ReceiptModal } from "components/Checkout/Receipt"
import SlidingPanel from 'components/SlidingPanel/SlidingPanel'
import Portal from 'components/Portal/Portal'
import ConnectedCheckout from 'components/Checkout/Checkout'
import { SUBROUTES_OBJ } from '../../App'

const MY_WORK_QUEUE_SEARCH_PLACEHOLDER = process.env.MY_WORK_QUEUE_SEARCH_PLACEHOLDER
const WQ_ALLOW_DELETE_PRINT_MAIL = process.env.WQ_ALLOW_DELETE_PRINT_MAIL
const WQ_ALLOW_EDIT_PENDING_PAYMENT = process.env.WQ_ALLOW_EDIT_PENDING_PAYMENT
const WQ_CONFIRM_ON_DELETE = process.env.WQ_CONFIRM_ON_DELETE
const WQ_DELETE_CONFIRM_MESSAGE = process.env.WQ_DELETE_CONFIRM_MESSAGE
const SHOPPING_CART = process.env.SHOPPING_CART
const MY_WORK_QUEUE_DISABLE_EMPTY_STATE = process.env.MY_WORK_QUEUE_DISABLE_EMPTY_STATE
const MY_WORK_QUEUE_EMPTY_STATE_LINE_1 = process.env.MY_WORK_QUEUE_EMPTY_STATE_LINE_1
const MY_WORK_QUEUE_EMPTY_STATE_LINE_2 = process.env.MY_WORK_QUEUE_EMPTY_STATE_LINE_2
const ALLOW_CORRECTION_STYLING = process.env.ALLOW_CORRECTION_STYLING
const MY_WORK_QUEUE_DESCRIPTION = process.env.MY_WORK_QUEUE_DESCRIPTION

class MyWorkQueue extends Component {
  state = {
    receiptOpen: false,
    highlightId: null,
    checkoutOpen: false,
    paymentDisabled: false,
    paymentDisabledId: null,
    deleteDialogOpen: false,
    deletingId: null
  }
  componentDidMount = () => {
    if (this.props.match.params.category) {
      if (
        !SUBROUTES_OBJ[this.props.match.params.category] ||
        !(SUBROUTES_OBJ[this.props.match.params.category].allowedRoutes || ['/queue/']).includes(
          '/queue/'
        )
      ) {
        this.props.history.replace('/404')
      } else {
        this.props.setActiveCategory(this.props.match.params.category)
        this.getRecords(this.props.match.params.category)
      }
    }
    // const params = parseUrlQuery(this.props.location.search)
    // if(params.receipt){
    //   this.setState({receiptOpen: true, highlightId: params.hid})
    //   this.props.history.replace(this.props.location.pathname)
    // }
  }
  componentWillReceiveProps = (nextProps) => {
    if (this.props.match.params.category !== nextProps.match.params.category) {
      if (
        SUBROUTES_OBJ[nextProps.match.params.category] &&
        (SUBROUTES_OBJ[nextProps.match.params.category].allowedRoutes || ['/queue/']).includes(
          '/queue/'
        )
      ) {
        this.props.setActiveCategory(nextProps.match.params.category)
        this.getRecords(nextProps.match.params.category)
      } else {
        this.props.history.replace('/404')
      }
    }
  }
  getRecords = (nextCategory, callback) => {
    this.props.fetchAndSetWorkQueueItems(nextCategory, callback)
  }
  edit = (e) => {
    console.log(e)
  }
  editDraft = (row) => {
    this.props.history.push('/draft/' + row.ID)
  }
  deleteDraft = (row) => {
    DELETE_DRAFT_BY_ID(row.ID, (response) => {
      this.getRecords(this.props.match.params.category)
    })
  }
  confirmDelete = (row) => {
    this.setState({ deletingId: row.ID, deleteDialogOpen: true })
  }
  deleteRecordById = () => {
    DELETE_RECORD_BY_ID(this.state.deletingId, this.props.match.params.category, (response) => {
      this.getRecords(this.props.match.params.category)
    }, (error) => {
      if(error.displayInWizard)
      {
        this.props.setErrorToast(error.message)
      }
      this.getRecords(this.props.match.params.category)
    })
  }
  closeDeleteDialog = () => {
    this.setState({ deleteDialogOpen: false, deletingId: null })
  }
  deleteRecord = (row) => {
    DELETE_RECORD_BY_ID(row.ID, this.props.match.params.category, (response) => {
      this.getRecords(this.props.match.params.category)
    }, (error) => {
      if(error.displayInWizard)
      {
        this.props.setErrorToast(error.message)
      }
      this.getRecords(this.props.match.params.category)
    })
  }
  downloadForm = (row) => {
    window.location.assign(
      BASE_URL + '/api/Report/FromReactPDF/' + row.FORM_DEFINITION_ID + '/' + row.AMENDMENT_NUM
    )
  }
  correct = (row) => {
    this.props.history.push('/correct/' + row.FORM_DEFINITION_ID + '/' + row.AMENDMENT_NUM)
  }
  viewReadOnlyForm = (row) => {
    this.props.history.push('/view/' + row.FORM_DEFINITION_ID + '/' + row.AMENDMENT_NUM)
  }
  downloadCorrectionLetter = (row) => {
    let correspondenceSourceId = 637
    window.location.assign(
      BASE_URL +
        '/api/Report/FromDatabase/' +
        row.IMAGE_DATA.CORRESPONDENCE_ID +
        '/' +
        correspondenceSourceId
    )
  }
  manageSignatures = (row) => {
    this.props.history.push('/signatures/' + row.GROUP_TOKEN)
  }
  amend = (row) => {
    this.props.history.push('/amend/' + row.FORM_DEFINITION_ID + '/' + row.AMENDMENT_NUM)
  }
  getReceiptItems = (amendmentNum) => {
    return new Promise((resolve, reject) => {
      GET_RECEIPT_ITEMS_BY_ADMENDMENT_NUM(
        amendmentNum,
        this.props.match.params.category,
        false,
        (receiptItems) => {
          resolve(receiptItems)
        },
        (error) => {
          reject(error)
          this.props.setErrorToast(error.message)
        }
      )
    })
  }
  startCheckout = ({ AMENDMENT_NUM, FORM_DEFINITION_ID }) => {
    this.disablePaymentButtons(AMENDMENT_NUM)
    this.getReceiptItems(AMENDMENT_NUM).then(
      ({ RECEIPT_ITEM_WEB_LIST, RECEIPT_ITEM_CONTAINER_WEB_LIST, REF_NUM }) => {
        const total = RECEIPT_ITEM_CONTAINER_WEB_LIST
          ? calculateReceiptItemContainersTotal(RECEIPT_ITEM_CONTAINER_WEB_LIST)
          : calculateReceiptItemsTotal(RECEIPT_ITEM_WEB_LIST)

        this.setState(
          {
            checkoutOpen: total > 0 ? true : false,
            checkoutDetails: {
              amendmentNum: AMENDMENT_NUM,
              formDefinitionId: FORM_DEFINITION_ID,
              receiptItems: RECEIPT_ITEM_WEB_LIST,
              receiptItemContainers: RECEIPT_ITEM_CONTAINER_WEB_LIST,
              refNum: REF_NUM,
            },
          },
          () => {
            if (SHOPPING_CART) {
              this.props.setCartQuantity(
                RECEIPT_ITEM_CONTAINER_WEB_LIST.filter((x) => !x.IS_FREE).length
              )
              this.getRecords(this.props.match.params.category)
            }
            if (total <= 0) {
              this.openReceipt()
            }
          }
        )
      }
    ).catch(error => {
        this.enablePaymentButtons()
        this.getRecords(this.props.match.params.category)
      }
    )
  }
  closeCheckout = () => {
    this.setState({ checkoutOpen: false })
    this.enablePaymentButtons()
  }
  cancelCheckout = () => {
    this.slider.closeSlider(() => {
      this.closeCheckout()
    })
  }
  disablePaymentButtons = (paymentDisabledId) => {
    this.setState({ paymentDisabled: true, paymentDisabledId })
  }
  enablePaymentButtons = () => {
    this.setState({ paymentDisabled: false, paymentDisabledId: null })
  }
  openReceipt = (refNum) => {
    // this.disablePaymentButtons()
    // this.getRecords(this.props.match.params.category, () => {
    //   this.enablePaymentButtons()
    // })
    if (this.slider) {
      this.slider.closeSlider(() => {
        // this.setState({checkoutOpen: false})
        this.props.history.push(`/receipt?ref=${refNum || this.state.checkoutDetails.refNum}`)
      })
    } else {
      this.props.history.push(`/receipt?ref=${refNum || this.state.checkoutDetails.refNum}`)
    }
  }
  selectItem = (row) => {
    this.props.selectWorkQueueItem(this.props.match.params.category, row.ID)
  }
  // closeReceipt = () => {
  //   const highlightId = this.state.highlightId;
  //   this.setState(state => ({receiptOpen: false, highlightId: null}))
  //   const rowIndex = this.props.orderedItems.rows.findIndex(row => row.RECORD_NUM === highlightId)
  //   if(rowIndex >= 0){
  //     this.highlightByIndex(rowIndex)
  //   }
  // }
  setFilters = (filters, props = {}) => {
    this.props.setFilters(this.props.match.params.category, filters)
    if (props.getRecords !== false) {
      this.getRecords(this.props.match.params.category)
    }
  }
  onSidebarDismiss = () => {
    this.props.selectWorkQueueItem(this.props.match.params.category, null)
  }
  highlightByIndex = (index) => {
    this.table.highlightRowByIndex(index)
  }
  viewAction = {
    iconClass: '',
    label: 'View Filing',
    className: 'primary',
    onClick: this.viewReadOnlyForm,
    children: <DocumentIcon />,
  }
  deleteAction = {
    iconClass: '',
    label: 'Delete',
    className: 'primary',
    onClick: (WQ_CONFIRM_ON_DELETE ? this.confirmDelete : this.deleteRecord),
    children: <TrashIcon />,
  }
  correctAction = {
    iconClass: '',
    label: 'Make a Correction',
    className: 'primary',
    onClick: this.correct,
    children: <PencilIcon />
  }
  viewDownloadsAction = {
    iconClass: '',
    label: 'View Downloads',
    className: row => row.TYPE == 'Needs_Correction' && ALLOW_CORRECTION_STYLING ? 'primary danger': 'primary',
    onClick: this.selectItem,
    children: <DownloadIcon />,
    getIsVisible: row => row.HAS_DOWNLOADS_AVAILABLE !== false
  }
  manageSignaturesAction = {
    iconClass: '',
    label: row => row.TYPE === 'Pending_Review' ? 'Review Signatures' : 'Manage Signatures',
    className: 'primary',
    onClick: this.manageSignatures,
    children: <SignatureIcon />,
    getIsVisible: row => !!row.GROUP_TOKEN
  }

  getLowercaseSublinkLabel = (sublink) =>
    sublink.preserveCasing ? sublink.label || '' : (sublink.label || '').toLowerCase()

  getMergedEmptyStateText = (text, sublink) =>
    text.replace(/{{CATEGORY}}/g, this.getLowercaseSublinkLabel(sublink))

  renderEmptyResults(props, sublink) {
    const renderEmpty =
      !MY_WORK_QUEUE_DISABLE_EMPTY_STATE &&
      !props.loading &&
      props.orderedItems &&
      props.orderedItems.rows &&
      !props.orderedItems.rows.length

    if (renderEmpty) {
      let line1 = `Looks like you don't have any ${this.getLowercaseSublinkLabel(
        sublink
      )} records in progress`
      let line2 = `Visit ${this.getLowercaseSublinkLabel(
        sublink
      )} forms to create your first record`
      if (MY_WORK_QUEUE_EMPTY_STATE_LINE_1) {
        line1 = this.getMergedEmptyStateText(MY_WORK_QUEUE_EMPTY_STATE_LINE_1, sublink)
      }
      if (MY_WORK_QUEUE_EMPTY_STATE_LINE_2) {
        line2 = this.getMergedEmptyStateText(MY_WORK_QUEUE_EMPTY_STATE_LINE_2, sublink)
      }
      return (
        <div className="empty-placeholder-wrapper">
          <EmptyBox />
          <h3>{line1}</h3>
          <p>{line2}</p>
          <div className="flex-row center">
            <Link
              className="btn btn-primary btn-raised"
              to={`/forms/${sublink.parameter}`}
              innerRef={(r) => (this.emptyLink = r)}
            >
              Go to {this.getLowercaseSublinkLabel(sublink)} forms
            </Link>
          </div>
        </div>
      )
    } else {
      return null
    }
  }

  refreshCart = () => {
    GET_WEB_USER_ACTIVE_CART(cart => {
      this.setState({
        receiptItemContainers: cart.RECEIPT_ITEM_CONTAINER_WEB_LIST,
        receiptItems: cart.RECEIPT_ITEM_WEB_LIST,
        refNum: this.cart.REF_NUM
      })
    })
    this.getRecords()
  }

  renderPageData(props) {
    if (props.error) {
      return <PageError errorDetails={props.errorDetails} />
    } else if (!props.orderedItems) {
      return <Spinner className="page-loader" />
    } else {
      const actionMap = {
        default: [
          {
            iconClass: '',
            label: 'View Filing',
            className: 'primary',
            onClick: this.viewReadOnlyForm,
            children: <DocumentIcon />,
          },
          this.viewDownloadsAction,
        ],
        Needs_Correction: [
          this.correctAction,
          this.viewDownloadsAction,
        ],
        Rejected: [
          {
            iconClass: '',
            label: 'View Filing',
            className: 'primary',
            onClick: this.viewReadOnlyForm,
            children: <DocumentIcon />,
          },
          this.viewDownloadsAction,
        ],
        Draft: [
          {
            iconClass: '',
            label: 'Resume Editing',
            className: 'primary',
            onClick: this.editDraft,
            children: <PencilIcon />,
          },
          {
            iconClass: '',
            label: 'Delete',
            className: 'primary',
            onClick: this.deleteDraft,
            children: <TrashIcon />,
          },
          this.viewDownloadsAction,
        ],
        Pending_Review: [this.viewAction, this.manageSignaturesAction, this.viewDownloadsAction],
        Approved: [this.viewAction, this.viewDownloadsAction],
        Pending_Print_and_Mail: [
          this.viewAction,
          ...(WQ_ALLOW_DELETE_PRINT_MAIL ? [this.deleteAction] : []),
          this.viewDownloadsAction,
        ],
        Pending_Signature: [this.viewAction, this.manageSignaturesAction],
        Pending_Online_Payment: (row) => [
          {
            iconClass: '',
            label: SHOPPING_CART ? 'Add to Cart' : 'Make Payment',
            className: 'primary',
            onClick: this.startCheckout,
            disabled: this.state.paymentDisabled,
            children:
              this.state.paymentDisabled && this.state.paymentDisabledId === row.AMENDMENT_NUM ? (
                !this.state.checkoutOpen ? (
                  <div className="spinner-wrapper">
                    <Spinner size="small" themeColor="dark-neutral" />
                  </div>
                ) : (
                  <CartIcon />
                )
              ) : (
                <CartIcon />
              ),
          },
          this.viewAction,
          this.manageSignaturesAction,
          this.viewDownloadsAction,
          this.deleteAction,
          ...(WQ_ALLOW_EDIT_PENDING_PAYMENT || SUBROUTES_OBJ[this.props.match.params.category].wqAllowEditPendingPayment ? [this.correctAction] : []),
        ],
        Static: [],
      }
      return (
        <div className="table-wrapper">
          <Table
            label="My Work Queue"
            className="center-container"
            template={props.orderedItems.template}
            rows={props.orderedItems.rows}
            actionCell={true}
            onCellClick={this.selectItem}
            actionMap={actionMap}
            selectedRowIndex={
              props.selectedId
                ? props.orderedItems.rows.findIndex((row) => row.ID === props.selectedId)
                : false
            }
            animated={false}
            ref={(ref) => {
              this.table = ref
            }}
            rowCount
          />
        </div>
      )
    }
  }

  render() {
    const {
      selectedId,
      items = {},
      activeCategory,
      location,
      sublinks,
      match,
      filters = {},
      loading,
    } = this.props
    const category = match.params.category
    const selectedItem = items[selectedId] || {}
    const selectedTitle = selectedItem.TITLE ? selectedItem.TITLE[0] : ''
    const selectedSubtitle = selectedItem.TITLE ? selectedItem.TITLE[1] : ''
    const sublink = sublinks.find((l) => l.parameter === category) || {}
    const activeFilters = filters[category] || {}
    return (
      <Body
        className="work-queue"
        showDrawer={selectedId}
        hiddenTitle="My Work Queue"
      >
        {!match.params.category && (
          <Redirect
            to={`${location.pathname}/${activeCategory ? activeCategory : sublinks[0].parameter}`}
          />
        )}
        <TableControls
          title={`My ${sublink.label} Work Queue`}
          description={sublink.myWorkQueueDescription || MY_WORK_QUEUE_DESCRIPTION || ''}
          filterTemplates={sublink.myWorkQueueFilters}
          filters={activeFilters}
          onFilterChange={this.setFilters}
          allowSearch={sublink.myWorkQueueSearch !== false}
          searchPlaceholder={MY_WORK_QUEUE_SEARCH_PLACEHOLDER || 'Search My Work Queue'}
          loading={loading}
        />

        {this.renderPageData(this.props)}

        {this.renderEmptyResults(this.props, sublink)}

        <Drawer
          showCloseButton
          show={selectedId ? true : false}
          title={selectedTitle}
          subtitle={selectedSubtitle}
          onSidebarDismiss={this.onSidebarDismiss}
        >
          {
            selectedItem.DRAWER_MESSAGE ? (
              <p className="drawer-message">{selectedItem.DRAWER_MESSAGE}</p>
            ) : null
          }
          <ReportsList
            formDefinitionId={selectedItem.FORM_DEFINITION_ID}
            amendmentNum={selectedItem.AMENDMENT_NUM}
            id={selectedItem.RECORD_NUM}
          />
        </Drawer>
        {/* <ReceiptModal isOpened={this.state.receiptOpen} onRequestModalClose={this.closeReceipt} /> */}
        <Portal isOpened={this.state.checkoutOpen}>
          <SlidingPanel
            closeOnShadeClick={false}
            closeSlider={this.closeCheckout}
            ref={(ref) => {
              this.slider = ref
            }}
          >
            <ConnectedCheckout
              cancelCheckout={this.cancelCheckout}
              closeModal={this.closeCheckout}
              redirectToReceipt={this.openReceipt}
              amendmentNum={this.state.checkoutOpen && this.state.checkoutDetails.amendmentNum}
              refNum={this.state.checkoutOpen && this.state.checkoutDetails.refNum}
              formDefinitionId={
                this.state.checkoutOpen && this.state.checkoutDetails.formDefinitionId
              }
              category={this.props.match.params.category}
              receiptItems={this.state.checkoutOpen && this.state.checkoutDetails.receiptItems}
              receiptItemContainers={
                this.state.checkoutOpen && this.state.checkoutDetails.receiptItemContainers
              }
              onReceiptItemContainerRemoved={() => this.getRecords(category)}
              onCartRefresh={this.refreshCart}
            />
          </SlidingPanel>
        </Portal>
        <Portal isOpened={this.state.deleteDialogOpen}>
          <ConfirmDialog
            closeModal={this.closeDeleteDialog}
            message={ WQ_DELETE_CONFIRM_MESSAGE ? WQ_DELETE_CONFIRM_MESSAGE : `Are you sure you want to delete this filing?`}
            buttons={[
              { label: 'No', onClick: noop, className: 'btn-default' },
              { label: 'Yes', onClick: this.deleteRecordById, className: 'btn-danger' }
            ]}
            modalStyle={{ borderRadius: 3 }}
          />
        </Portal>
      </Body>
    )
  }
}
export default connect(
  (state, props) => ({
    items:
      props.match.params.category && state.queue.items
        ? state.queue.items[props.match.params.category]
        : {},
    orderedItems: state.queue.items
      ? getOrderedResultsByCategory(
          props.match.params.category,
          state.queue.items,
          state.queue.templates
        )
      : {},
    selectedId: props.match.params.category
      ? state.queue.selected[props.match.params.category]
      : null,
    activeCategory: state.queue.activeCategory || state.app.currentCategory,
    filters: state.queue.filters,
    loading: state.queue.loading,
    error: state.queue.error,
    errorDetails: state.queue.errorDetails,
  }),
  { fetchAndSetWorkQueueItems, selectWorkQueueItem, setActiveCategory, setFilters, setCartQuantity, setErrorToast }
)(MyWorkQueue)



// WEBPACK FOOTER //
// ./src/components/MyWorkQueue/MyWorkQueue.js